import { FC } from 'react';

import Box, { BoxProps } from '@mui/material/Box';

type Props = BoxProps;

const NonBreakingDate: FC<Props> = ({ sx, ...props }) => (
  <Box
    component="span"
    sx={[{ whiteSpace: 'nowrap' }, ...(Array.isArray(sx) ? sx : [sx])]}
    {...props}
  />
);

export default NonBreakingDate;
